import React, { useEffect, useState } from "react";
import {
  Stack,
  Text,
  Separator,
  Persona,
  DefaultEffects,
  PersonaSize
} from "@fluentui/react";
import { t } from "@lingui/macro";
import { i18n } from "idc-ui-react";

export default function Herocard(props) {
  const { loggedInUser, urls } = props;

  const [initials, setInitials] = useState("");

  useEffect(() => {
    if (!loggedInUser) return;
    if (loggedInUser.name.initials) {
      setInitials(loggedInUser.name.initials);
    } else {
      const fullName = loggedInUser.name.fullName;
      const names = fullName.split(" ");
      const firstInitial = names[0].charAt(0);
      const lastInitial = names[names.length - 1].charAt(0);
      setInitials(firstInitial + lastInitial);
    }
  }, [loggedInUser]);

  return (
    <Stack
      styles={{
        root: {
          display: "flex",
          flexDirection: "column",
          height: "320px",
          minWidth: "300px",
          position: "relative",
          marginTop: "20px"
        }
      }}
    >
      <Persona
        imageInitials={initials}
        size={PersonaSize.size100}
        styles={{
          root: {
            position: "absolute",
            left: "58%",
            top: "-10%",
            transform: "translateX(-50%)"
          }
        }}
      />
      <Stack
        styles={{
          root: {
            display: "flex",
            flexDirection: "column",
            height: "100%",
            width: "100%",
            textAlign: "center",
            borderRadius: "5px",
            boxShadow: DefaultEffects.elevation8
          }
        }}
      >
        {loggedInUser && (
          <Stack
            styles={{
              root: {
                display: "flex",
                flexDirection: "column",
                height: "50%",
                marginTop: "85px",
                textAlign: "Left",
                marginLeft: "20px",
                alignItems: "center"
              }
            }}
          >
            <Text variant="xLarge">{loggedInUser.name.fullName}</Text>
          </Stack>
        )}
        <Separator />
        <Stack
          styles={{
            root: {
              marginTop: "auto"
            }
          }}
        >
          <button
            style={{
              background: "none",
              border: "none",
              padding: "0",
              color: "#4992db",
              outline: "inherit",
              cursor: "pointer"
            }}
            onClick={() => (window.location.href = urls.logout)}
          >
            {i18n._(t`Logout`)}
          </button>
        </Stack>
      </Stack>
    </Stack>
  );
}
